import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
function Testimonial() {
  return (
    <div className="section section-padding testimonial-section">
      {/* <img
class="shape-1 movebounce-03"
src="assets/images/shape/shape-14.webp"
width="212"
height="191"
alt="Shape"
/> */}
      <div className="container">
        {/* Section Title Start */}
        <div className="section-title text-center">
          <h6 className="sub-title">CLIENT TESTIMONALS</h6>
          <h2 className="title">WHAT OUR CLIENTS SAY</h2>
          <p />
        </div>
        {/* Section Title End */}
        {/* Testimonial Wrapper Start */}
        <div
          className="testimonial-wrapper testimonial-active"
          data-aos="fade-up"
          data-aos-delay={200}
        >
          <div className="row row-cols-12 row-cols-lg-12">
            <div className="">
              <div className="swiper-container">
                <Swiper
                  modules={[Pagination]}
                  spaceBetween={50}
                  autoplay={1000}
                  pagination={{ clickable: true }}
                  scrollbar={{ draggable: true }}
                  slidesPerView={2}
                  onSlideChange={() => console.log("slide change")}
                  onSwiper={(swiper) => console.log(swiper)}
                >
                  <SwiperSlide>
                    <div className="swiper-slide single-testimonial">
                      <div className="testimonial-content">
                        <p>
                          I visited
                          <strong> Swakaaya Wellness Clinic</strong> for hair
                          loss treatment, and I’m satisfied with the results, my
                          treatment is still going on. Thank you, team!
                        </p>
                        <h4 className="name">Rahul Kumar</h4>
                        <div className="rating">
                          <div
                            className="rating-star"
                            style={{ width: "100%" }}
                          />
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="swiper-slide swiper-slide single-testimonial">
                      <div className="testimonial-author"></div>
                      <div className="testimonial-content">
                        <p>
                          Got my filler injection done by this clinic and I
                          absolutely loved it. The doctor is amazing and
                          experienced. She has a friendly nature and will make
                          you comfortable throughout the procedure.
                        </p>
                        <h4 className="name">Sneha Arora</h4>
                        <div className="rating">
                          <div
                            className="rating-star"
                            style={{ width: "80%" }}
                          />
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="swiper-slide swiper-slide single-testimonial">
                      <div className="testimonial-author"></div>
                      <div className="testimonial-content">
                        <p>
                          Got my filler injection done by this clinic and I
                          absolutely loved it. The doctor is amazing and
                          experienced. She has a friendly nature and will make
                          you comfortable throughout the procedure.
                        </p>
                        <h4 className="name">Sneha Arora</h4>
                        <div className="rating">
                          <div
                            className="rating-star"
                            style={{ width: "80%" }}
                          />
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="swiper-slide swiper-slide single-testimonial">
                      <div className="testimonial-author"></div>
                      <div className="testimonial-content">
                        <p>
                          Got my filler injection done by this clinic and I
                          absolutely loved it. The doctor is amazing and
                          experienced. She has a friendly nature and will make
                          you comfortable throughout the procedure.
                        </p>
                        <h4 className="name">Sneha Arora</h4>
                        <div className="rating">
                          <div
                            className="rating-star"
                            style={{ width: "80%" }}
                          />
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="swiper-slide swiper-slide single-testimonial">
                      <div className="testimonial-author"></div>
                      <div className="testimonial-content">
                        <p>
                          Got my filler injection done by this clinic and I
                          absolutely loved it. The doctor is amazing and
                          experienced. She has a friendly nature and will make
                          you comfortable throughout the procedure.
                        </p>
                        <h4 className="name">Sneha Arora</h4>
                        <div className="rating">
                          <div
                            className="rating-star"
                            style={{ width: "80%" }}
                          />
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="swiper-slide swiper-slide single-testimonial">
                      <div className="testimonial-author"></div>
                      <div className="testimonial-content">
                        <p>
                          Got my filler injection done by this clinic and I
                          absolutely loved it. The doctor is amazing and
                          experienced. She has a friendly nature and will make
                          you comfortable throughout the procedure.
                        </p>
                        <h4 className="name">Sneha Arora</h4>
                        <div className="rating">
                          <div
                            className="rating-star"
                            style={{ width: "80%" }}
                          />
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <div className="swiper-button-next" />
                  <div className="swiper-button-prev" />
                </Swiper>
              </div>
            </div>
          </div>
        </div>
        {/* Testimonial Wrapper End */}
      </div>
    </div>
  );
}

export default Testimonial;
